// @flow

export default {
  CART_NOTIFICATION: 'cart-notification-modal',
  CROSS_SELL_NOTIFICATION: 'cross-sell-notification-modal',
  CROSS_SELL_MODAL: 'cross-sell-modal'
};
